import  { useEffect, useState } from "react";
import { ODataReportS3 } from "./StimulsoftReports";
import { S3_REPORTS_URL } from "../../../utils/constant";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const ODataReportViewer = ({ fileName }) => {
  const accessToken = localStorage.getItem("accessToken")
  const [searchParams] = useSearchParams()
  const [reportObject, setReportObject] = useState(null)
  let instance = axios.create({
    headers: {
    },
  });

  const getReport = async () => {
    try {
      const fileName = searchParams.get("fileName") || fileName
      const { data } = await instance.get(`${S3_REPORTS_URL}/${fileName}`)
      setReportObject(data)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getReport()
  }, [])

  useEffect(() => {
    if (reportObject) {
      let filters = ''
      if (searchParams.size > 0) {
        filters = `?${searchParams.toString()}`
      }

      let report = new ODataReportS3({
        reportFile: reportObject,
        accessToken: accessToken,
        filters: filters
      });
      report.viewer.renderHtml("viewer");
    }
  }, [reportObject])

  return <div id="viewer"></div>;
};

export default ODataReportViewer;